export default class TextColorInlineTool {
  static get isInline() {
    return true
  }

  static get sanitize() {
    return {
      span: {
        class: true,
        style: true
      }
    }
  }

  constructor({ api, config }) {
    this.api = api
    this.button = null
    this.config = config || {}
    this.color = this.config.color || "#215287"
    this.className = this.config.className || "article-text-brand"
    this.label = this.config.label || "A"
    this.title = this.config.title || "Text color"
    this.knownClasses = ["article-text-brand", "article-text-accent"]
  }

  render() {
    this.button = document.createElement("button")
    this.button.type = "button"
    this.button.classList.add(this.api.styles.inlineToolButton)
    this.button.setAttribute("aria-label", this.title)
    this.button.innerHTML = `<span style="color:${this.color};font-weight:700;">${this.label}</span>`
    return this.button
  }

  surround(range) {
    if (!range || range.collapsed) return

    const sameColor = this.api.selection.findParentTag("SPAN", this.className)
    if (sameColor) {
      this.unwrap(sameColor)
      return
    }

    this.knownClasses
      .filter((cssClass) => cssClass !== this.className)
      .forEach((cssClass) => {
        const parent = this.api.selection.findParentTag("SPAN", cssClass)
        if (parent) this.unwrap(parent)
      })

    this.wrap(range)
  }

  checkState() {
    const colored = this.api.selection.findParentTag("SPAN", this.className)
    this.button.classList.toggle(this.api.styles.inlineToolButtonActive, !!colored)
    return !!colored
  }

  wrap(range) {
    const span = document.createElement("span")
    span.classList.add(this.className)
    span.style.color = this.color
    span.appendChild(range.extractContents())
    range.insertNode(span)
    this.api.selection.expandToTag(span)
  }

  unwrap(span) {
    const parent = span.parentNode
    if (!parent) return

    while (span.firstChild) {
      parent.insertBefore(span.firstChild, span)
    }
    parent.removeChild(span)
  }
}
